import React from 'react';
import { Link } from 'react-router-dom';
import { Reveal } from '@/components/motion';

export const PillLink = ({ to, href, children, variant = 'primary', testId, ...rest }) => {
  const base = 'inline-flex items-center justify-center gap-2 rounded-full px-8 py-4 text-lg font-semibold transition-transform duration-200 hover:scale-[0.97] active:scale-95';
  const styles = {
    primary: 'bg-terracotta text-beige shadow-sm shadow-terracotta/30',
    outline: 'border-2 border-textDark/25 text-textDark hover:border-terracotta hover:text-terracotta',
    sage: 'bg-salvia text-textDark',
  };
  const cls = `${base} ${styles[variant]}`;
  if (href) return <a href={href} className={cls} data-testid={testId} {...rest}>{children}</a>;
  return <Link to={to} className={cls} data-testid={testId} {...rest}>{children}</Link>;
};

export const PillButton = ({ children, variant = 'primary', testId, className = '', ...rest }) => {
  const base = 'inline-flex items-center justify-center gap-2 rounded-full px-8 py-4 text-lg font-semibold transition-transform duration-200 hover:scale-[0.97] active:scale-95 disabled:opacity-60';
  const styles = {
    primary: 'bg-terracotta text-beige shadow-sm shadow-terracotta/30',
    outline: 'border-2 border-textDark/25 text-textDark hover:border-terracotta',
    sage: 'bg-salvia text-textDark',
  };
  return <button className={`${base} ${styles[variant]} ${className}`} data-testid={testId} {...rest}>{children}</button>;
};

export const SectionHead = ({ eyebrow, title, subtitle, align = 'left', dark = false }) => (
  <Reveal className={`max-w-2xl ${align === 'center' ? 'mx-auto text-center' : ''}`}>
    {eyebrow && (
      <span className={`inline-block mb-4 text-sm font-semibold tracking-[0.18em] uppercase ${dark ? 'text-salvia' : 'text-terracotta'}`}>
        {eyebrow}
      </span>
    )}
    <h2 className={`font-serif text-4xl sm:text-5xl leading-[1.05] ${dark ? 'text-beige' : 'text-textDark'}`}>{title}</h2>
    {subtitle && <p className={`mt-5 text-xl ${dark ? 'text-beige/75' : 'text-textDark/70'}`}>{subtitle}</p>}
  </Reveal>
);

export const PageHero = ({ eyebrow, title, subtitle, ornament }) => (
  <section className="relative overflow-hidden pt-16 pb-14 md:pt-24 md:pb-20 px-5 md:px-10">
    <div className="max-w-[1280px] mx-auto">
      <Reveal>
        <span className="inline-block mb-5 text-sm font-semibold tracking-[0.18em] uppercase text-terracotta">{eyebrow}</span>
      </Reveal>
      <Reveal delay={0.08}>
        <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl leading-[0.98] text-textDark max-w-4xl">{title}</h1>
      </Reveal>
      {subtitle && (
        <Reveal delay={0.16}>
          <p className="mt-7 text-xl md:text-2xl text-textDark/70 max-w-2xl leading-relaxed">{subtitle}</p>
        </Reveal>
      )}
    </div>
    {ornament}
  </section>
);
